import React from 'react'

const ImageElement = ({ content, title, aspectRatio = '6/4' }) => {
  return (
    <div style={{ width: '100%', aspectRatio: aspectRatio, overflow: 'hidden' }}>
      <img
        src={content}
        alt={title || ''}
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover'
        }}
      />
    </div>
  )
}

export default ImageElement